import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    earningTab: "Commission"
} 

const earningSlice = createSlice({
    name: 'earning',
    initialState,
    reducers: {
        setEarningStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        clearEarning(action, state) {
            return initialState
        },
    }
})

export const earningActions = earningSlice.actions;
export default earningSlice;